/**
 * The sales inbox. GH-894 made the "book a demo" / "keep me informed" form real (it posts to
 * `POST /v1/public/sales-leads` — see `src/api/sales-lead.ts`), so this address is now a fallback
 * path only: the footer and the privacy dialog offer it for anyone who would rather email
 * directly than use the form.
 */
export const CONTACT_EMAIL = "hello@givehere.co";
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;
